import type { FreelancerInsuranceInformationPageLocales } from '../types';

const freelancerInsuranceInformationPageLocales: FreelancerInsuranceInformationPageLocales =
  {
    confirmDeleteMessage:
      'Are you sure you want to delete {{docName}}? If you make a mistake, you can manually add the diploma again.',
    documentAdded: 'Document saved successfully.',
    documentDeleted: 'Document deleted!',
    fileRequired: 'You must select a file.',
    helperMessage:
      "Please upload proof of your company's liability insurance below.",
    removeDocument: 'Remove document',
    saveDocument: 'Save document',
    title: 'Insurance',
    uploadErrorMessage: 'Could not upload file, please try again later.',
    uploadProof: 'Upload proof',
    wantToContinue: 'Are you sure you want to continue?',
    wrongFileExtension:
      'Document does not have the correct extension. Upload a PDF, JPG or PNG file',
    yesRemoveDocument: 'Yes, remove document',
  };

export default freelancerInsuranceInformationPageLocales;
